import { useQuery } from '@tanstack/react-query';
import showToast from '../components/ToastComponent';
import { getProductBrand } from '../service/getProductBrands';
import { ProductBrands } from '../constant/constant';

export const useProductBrands = (token?: string) => {
  const { data: brands, isLoading: isBrandLoading } = useQuery({
    queryKey: ['productBrand', token],
    queryFn: async () => {
      const result = await getProductBrand(token!);
      if (typeof result === 'number') {
        showToast({
          message: 'Unable to fetch product brand!',
          type: 'error',
        });
        return null;
      }

      const filteredBrands = result
        .filter(
          (x: { product_brand: string }) =>
            x.product_brand !== ProductBrands.ATLUS,
        )
        .map((e: { product_brand: string }) => ({
          label: e.product_brand,
          value: e.product_brand,
        }));
      return filteredBrands;
    },
  });

  return { brands, isBrandLoading };
};
